import { render, staticRenderFns } from "./pressalitList.vue?vue&type=template&id=6dc5b90e&lang=pug&"
import script from "./pressalitList.vue?vue&type=script&lang=js&"
export * from "./pressalitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports